export const newableSyncClientRTTI = Symbol.for("NewableSyncClient");
export const syncRTTI = Symbol.for("Sync");
export const syncProviderRTTI = Symbol.for("SyncProvider");
export const syncCacheRTTI = Symbol.for("SyncCache");
export const syncMapProviderRTTI = Symbol.for("SyncMapProvider");
export const syncMapItemProviderRTTI = Symbol.for("SyncMapItemProvider");
export const newableSyncMapRTTI = Symbol.for("NewableSyncMap");
export const newableSyncMapItemRTTI = Symbol.for("NewableSyncMapItem");
